import React, { useState } from "react";
import { useStore } from "store";
import axios from "axios";
import strings from "resources/strings";
import { Flex, Typography, Button, Modal, Alert, message } from "antd";
const { Text } = Typography;

import "./style.scss";
const styleWrapperClass = "ModalSatCertsDelete";

function ModalSatCertsDelete({ openTitle }) {
  const token = useStore((state) => state.token);
  const user = useStore((state) => state.user);
  const activeRfc = useStore((state) => state.activeRfc);
  const updateUserRfc = useStore((state) => state.updateUserRfc);

  const active_rfc_obj = user.rfcs[activeRfc];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHandlingRequest, setIsHandlingRequest] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsHandlingRequest(false);
    setIsModalOpen(false);
  };

  const handleOk = async () => {
    setIsHandlingRequest(true);

    //Call server
    await postCredentialsDelete(active_rfc_obj.rfc);

    //Clear local variables and refresh
    active_rfc_obj.sat_credentials_status = "no_credentials";
    active_rfc_obj.refresh_status = "inactive";
    updateUserRfc(active_rfc_obj);

    handleCancel();
  };

  const postCredentialsDelete = async (rfc) => {
    let path = "/user/rfc/sat-delete";
    let headers = { token: token };
    let payload = {
      data: {
        rfc: rfc,
      },
    };
    const response = await axios
      .post(path, payload, { headers })
      .catch((error) => {
        message.error(strings.alertUnexpectedError);
        return false;
      });

    if (response.data.response.code !== 2000) {
      message.error(strings.alertUnexpectedError);
    }
  };

  return (
    <div className={styleWrapperClass}>
      <Button danger onClick={showModal}>
        {openTitle}...
      </Button>

      <Modal
        title={openTitle}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={860}
        destroyOnClose={true}
        footer={null}
        maskClosable={!isHandlingRequest}
        closable={!isHandlingRequest}
      >
        <Flex vertical gap={20}>
          <Text>
            Si eliminas tu certificado, se pausará la actualización de tus CFDIs
            y no podrás visualizar nuevos CFDIs. Podrás seguir viendo y buscando
            tus CFDIs anteriores.
          </Text>
          <Alert
            message="¡El certificado se borrará permanentemente y deberás registrar uno
            nuevo usando tus archivos .CER y .KEY!"
            type="warning"
            showIcon
          />
          <Flex style={{ marginTop: "20px" }} gap={10} justify="flex-end">
            <Button
              type="primary"
              disabled={isHandlingRequest}
              onClick={handleCancel}
            >
              Cancelar
            </Button>
            <Button
              type="primary"
              danger
              loading={isHandlingRequest}
              onClick={handleOk}
            >
              {openTitle}
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </div>
  );
}

export default ModalSatCertsDelete;
